var _defs, _path, _rect, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.45 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2{stroke:#696969;stroke-miterlimit:10;stroke-width:1.5px;}.cls-2{fill:#fff;}.cls-3{fill:#696969;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.23.75h0A5.28,5.28,0,0,1,13.5,6V7.36a.48.48,0,0,1-.48.48H3.43a.48.48,0,0,1-.48-.48V6A5.28,5.28,0,0,1,8.23.75Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.75,
    y: 7.69,
    width: 14.95,
    height: 12.56,
    rx: 1.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 8.23,
    cy: 12.66,
    r: 1.71
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.46,14H9a0,0,0,0,1,0,0v3a.76.76,0,0,1-.76.76h0A.76.76,0,0,1,7.46,17V14a0,0,0,0,1,0,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock1);
export default __webpack_public_path__ + "static/media/Lock1.bb1aa3427b039039f439cce33806150f.svg";
export { ForwardRef as ReactComponent };